import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/dropdown-button/dropdown-button.js';
      import {ObcDropdownButtonChangeEvent, DropdownButtonType} from '@oicl/openbridge-webcomponents/dist/components/dropdown-button/dropdown-button.js';

      export interface Props {
     options?: { value: string; label: string; level?: number | undefined; }[];
     value?: string | undefined;
     disabled?: boolean;
     fullWidth?: boolean;
     type?: DropdownButtonType;
     openTop?: boolean;
     integration?: boolean;
     flat?: boolean
   }

      
  
      export type {ObcDropdownButtonChangeEvent, DropdownButtonType} from '@oicl/openbridge-webcomponents/dist/components/dropdown-button/dropdown-button.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcDropdownButton',
  props: {
    options: {},
    value: {},
    disabled: { type: Boolean },
    fullWidth: { type: Boolean },
    type: {},
    openTop: { type: Boolean },
    integration: { type: Boolean },
    flat: { type: Boolean }
  },
  emits: ["dropdown-change", "change"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onDropdownChange: (event: ObcDropdownButtonChangeEvent) => emit('dropdown-change', event as ObcDropdownButtonChangeEvent),
onChange: (event: ObcDropdownButtonChangeEvent) => emit('change', event as ObcDropdownButtonChangeEvent)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-dropdown-button',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})